import { Component, Input } from '@angular/core';
import { NewsContentPageSection } from 'src/app/model/section/news-content-page-section';

@Component({
  selector: 'app-additional-page-section',
  templateUrl: './additional-page-section.component.html',
  styleUrls: ['./additional-page-section.component.scss']
})
export class AdditionalPageSectionComponent {
  @Input() sections: NewsContentPageSection[] = [];
  constructor() {}
}
